import { Reveal } from "@/lib/motion";
import { StarBleed } from "./CosmicField";

const WORDS = [
  "Portfolio thinking",
  "AI-native products",
  "Long-term platforms",
  "Real-world utility",
  "Intelligent software",
  "Built for scale",
];

export const Marquee = () => (
  <div
    data-testid="marquee"
    className="relative border-y border-white/[0.06] py-6 overflow-hidden select-none"
  >
    <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#0a0a0f] to-transparent z-10" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#0a0a0f] to-transparent z-10" />
    <div className="marquee-track">
      {[...WORDS, ...WORDS].map((w, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display text-2xl sm:text-4xl font-500 text-white/12 whitespace-nowrap px-8">
            {w}
          </span>
          <span className="text-violet-400/40 text-xl">✦</span>
        </div>
      ))}
    </div>
  </div>
);

export const Intro = () => (
  <section id="intro" data-testid="intro-section" className="relative py-28 sm:py-40">
    <StarBleed count={14} height="h-[560px]" opacity={0.55} />
    <div
      aria-hidden="true"
      data-testid="company-atmosphere"
      className="pointer-events-none absolute inset-x-0 top-0 h-[380px] sm:h-[440px]"
      style={{ background: "radial-gradient(85% 60% at 50% 0%, rgba(56,189,248,0.055), rgba(139,92,246,0.03) 50%, transparent 88%)" }}
    />
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-start">
        <div className="lg:col-span-4">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] text-violet-300/80">
              01 — The Company
            </span>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal delay={0.05}>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-500 leading-[1.12] tracking-[-0.02em] text-white">
              ArcaCentum is a parent technology company developing a
              portfolio of{" "}
              <span className="text-gradient">AI-powered products</span> and
              intelligent platforms.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 max-w-2xl text-base sm:text-lg leading-relaxed text-white/55 font-light">
              We are not building one-off tools. ArcaCentum takes a long-term,
              platform-first approach, engineering foundational AI systems that
              power a growing family of products. Each product stands on its own,
              while sharing the same core belief: that intelligent software should
              make ambitious ideas easier to build and launch.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
